import React, { useEffect, useRef } from "react";
import LayoutUI from "@/componentsUI/Layout";
import "./styles/index.less";
import Bottombar from "@/components/Bottombar";
import {
  useGlobalOpenRedPack,
  useGlobalOpenSearch,
  useGlobalOpenUserCenter,
  useGlobalOpenWallet,
  useHeaderHeight,
  useMobileLeftSiderSwitch
} from "@/store/commonStore";
import SearchDrawer from "./components/SearchDrawer/SearchDrawer";
import HandleNoticeRead from "./components/notice/Notice";
import SiderLeftMenu from "./components/siderLeftMenu/SiderLeftMenu";
import LayoutMain from "./components/layoutMain/LayoutMain";
import LayoutHeader from "./components/layoutHeader/LayoutHeader";
import RedpackRainPage from "@/pages/redpackRain/redpackRainPage/RedpackRainPage";
import MobileWallet from "@/pages/mobilewallet/MobileWallet";
import MobileCenteredShell from "./components/mobileCenteredShell/MobileCenteredShell";
import { getDynamicViewportHeight } from "@/utils/viewportHeight";

function PageLayoutContent() {
  const prefixCls = "JHJ-layout-main";
  const [searchVisible] = useGlobalOpenSearch();
  const [drawerVisible] = useMobileLeftSiderSwitch();
  const [walletVisible] = useGlobalOpenWallet();
  const [userCenterVisible] = useGlobalOpenUserCenter();
  const [, setHeaderHeight] = useHeaderHeight();
  const layoutMainRef = useRef(null);
  const layoutHeadRef = useRef(null);
  const layoutSearchViewRef = useRef(null);
  /**不要修改 用于适配ios手机内容区域适配 */
  useEffect(() => {
    const elementRoot = document.getElementById("layout-container-id");
      if (elementRoot) {
        elementRoot.style.height = getDynamicViewportHeight();
        elementRoot.style.minHeight = "auto";
      }
  }, []);
  /**处理内容区域高度 */
  useEffect(() => {
    const element = layoutHeadRef.current;
    if (!element) return;

    const resizeObserver = new ResizeObserver(() => {
      if (!layoutMainRef.current) return;

      layoutMainRef.current.style.marginTop = element.clientHeight + "px";
      setHeaderHeight(element.clientHeight);
      if (layoutSearchViewRef.current) {
        layoutSearchViewRef.current.style.marginTop = "0px";
      }
    });
    resizeObserver.observe(element);
    return () => {
      resizeObserver.disconnect();
    };
  }, [searchVisible]);

  useEffect(() => {
    document.body.dataset.mobileCenteredShellPanelActive =
      searchVisible || drawerVisible || walletVisible || userCenterVisible
        ? "true"
        : "false";

    return () => {
      delete document.body.dataset.mobileCenteredShellPanelActive;
    };
  }, [searchVisible, drawerVisible, walletVisible, userCenterVisible]);

  const [openRed] = useGlobalOpenRedPack();
  return (
    <LayoutUI className={`${prefixCls} web2-fadein`} id={"layout-container-id"}>
      {/** 布局顶部菜单栏 */}
      <LayoutHeader ref={layoutHeadRef} className={`${prefixCls}-header`} />
      {/**左侧菜单布局 */}
      <SiderLeftMenu />
      {/** 主布局内容区 */}
      <LayoutMain ref={layoutMainRef} className={`${prefixCls}-layout-main`} />
      {/*底部导航*/}
      <Bottombar />
      {/*搜索*/}
      <SearchDrawer innerRef={layoutSearchViewRef} />
      {/**处理消息已读 */}
      <HandleNoticeRead />

      <MobileWallet />

      {/* 用户中心 - 已移至Topbar组件中 */}

      {openRed && <RedpackRainPage />}
    </LayoutUI>
  );
}

function PageLayout() {
  return (
    <MobileCenteredShell>
      <PageLayoutContent />
    </MobileCenteredShell>
  );
}

export default React.memo(PageLayout);
